import { DeconstructedURL } from '@sonar-software/sonar-ts-lib';
import { GatewayContent } from '../general';
import { QUERY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnMount, useSalesforceLink } from '@hooks';
export const SalesforceIntegration = () => {
    const navigate = useNavigate();
    const link = useSalesforceLink();
    useOnMount(() => {
        var _a, _b, _c;
        const currentUrl = new DeconstructedURL(window.location.href);
        const targetRoute = (_a = currentUrl.searchParams.get(QUERY.STATE)) !== null && _a !== void 0 ? _a : '';
        const targetUrl = new DeconstructedURL(targetRoute);
        if (targetUrl.subdomain && targetUrl.subdomain !== currentUrl.subdomain) {
            currentUrl.subdomain = targetUrl.subdomain;
            window.location.replace(currentUrl.toString());
            return;
        }
        const code = (_b = currentUrl.searchParams.get(QUERY.CODE)) !== null && _b !== void 0 ? _b : '';
        const organizationId = (_c = targetUrl.searchParams.get(QUERY.ORGANIZATION)) !== null && _c !== void 0 ? _c : '';
        if (!code || !organizationId) {
            navigate('/', { replace: true });
        }
        targetUrl.searchParams.delete(QUERY.ORGANIZATION);
        link({
            code,
            onResponse: (result) => {
                const hasResult = Boolean(result);
                targetUrl.searchParams.append(QUERY.SALESFORCE_REAUTHENTICATION, hasResult.toString());
                navigate({
                    pathname: targetUrl.pathname,
                    search: targetUrl.search
                });
            },
            organizationId: Number(organizationId)
        });
    });
    return React.createElement(GatewayContent, null);
};
